import { Box, Grid } from '@material-ui/core';
import Sidebar from 'components/Common/Navigation/Sidebar';
import UserContext from 'context/UserContext';
import { useContext } from 'react';

const Layout: React.FC = ({ children }) => {
  const { logout } = useContext(UserContext);

  return (
    <>
      <Sidebar onLogout={logout} />
      <Box marginLeft="240px" paddingX={10} paddingTop={7}>
        <Grid container direction="column" spacing={7}>
          {children}
        </Grid>
      </Box>
    </>
  );
};

export default Layout;
